export function UploadModes(client) {
    return {
        get(category) {
            return client.get(`/categories/${category}/upload-modes`);
        }
    };
}
